export default __webpack_public_path__ + "static/sfx-bg_5-f66d7df2ef2bdca6d909ecd75a3f92e8.png";